import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { renderDataTypeWithComma } from "@/lib/utils/renderType";
import { getExpertVariantQuestionUrl } from "@/settings/constant";
import { IconV2, Typography } from "@bookips/sds";
const BUTTON_NAME = "이 교재로 변형문제 무제한 사용하기";
/** 출처 교재가 엑스퍼트에서 변형문제 생성 가능할 때만 노출되는 엑스퍼트 이동 링크 */ const ExpertVariantLink = (param)=>{
    let { product  } = param;
    var _expertCoverage_subject;
    const { expertCoverage  } = product;
    const subject = expertCoverage === null || expertCoverage === void 0 ? void 0 : (_expertCoverage_subject = expertCoverage.subject) === null || _expertCoverage_subject === void 0 ? void 0 : _expertCoverage_subject.toLowerCase();
    const baseSourceId = expertCoverage === null || expertCoverage === void 0 ? void 0 : expertCoverage.baseSourceId;
    // 현재 변형문제 생성 페이지가 있는 과목은 영어/국어뿐
    if (!baseSourceId || subject !== "en" && subject !== "ko") return null;
    const href = getExpertVariantQuestionUrl(subject, baseSourceId);
    const source = product.source;
    const handleClick = ()=>{
        var _source_based_textbook_title, _renderDataTypeWithComma, _source_subject;
        const property = {
            Position: "상품상세페이지 샘플보기 하단",
            "Button Type": "Expert Entry",
            "Button Name": BUTTON_NAME,
            "Button URL": href,
            // 엑스퍼트 기준 출처 교재 id (마켓 base_source_id와 동일 값이나, 정밀도 보존을 위해 문자열 사용)
            "Source Id": baseSourceId,
            "Source Title": (_source_based_textbook_title = source === null || source === void 0 ? void 0 : source.based_textbook_title) !== null && _source_based_textbook_title !== void 0 ? _source_based_textbook_title : "",
            "Handout Type": (_renderDataTypeWithComma = renderDataTypeWithComma(source === null || source === void 0 ? void 0 : source.data_type)) !== null && _renderDataTypeWithComma !== void 0 ? _renderDataTypeWithComma : "",
            Subject: (_source_subject = source === null || source === void 0 ? void 0 : source.subject) !== null && _source_subject !== void 0 ? _source_subject : "",
            "Product Id": String(product.id)
        };
        mixpanelEvent("Link Button Clicked", property);
    };
    return /*#__PURE__*/ _jsxs("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: cn("mt-4 flex items-center justify-center gap-1", "max-md:hidden"),
        onClick: handleClick,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle2",
                as: "span",
                className: "text-primary-main",
                children: BUTTON_NAME
            }),
            /*#__PURE__*/ _jsx(IconV2.ExternalLink, {
                className: "text-primary-main size-3.5"
            })
        ]
    });
};
export default ExpertVariantLink;
